import React, { useState } from "react";

function WorkerMaster() {

  const [formData, setFormData] = useState({
    workerName: "",
    mobile: "",
    role: "",
    salary: "",
    joinDate: "",
    status: ""
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const validate = () => {
    let tempErrors = {};

    if (!formData.workerName)
      tempErrors.workerName = "Worker Name required";

    if (!formData.mobile) {
      tempErrors.mobile = "Mobile required";
    } else if (!/^[0-9]{10}$/.test(formData.mobile)) {
      tempErrors.mobile = "Enter valid 10 digit number";
    }

    if (!formData.role)
      tempErrors.role = "Select Role";

    if (!formData.salary)
      tempErrors.salary = "Salary required";

    if (!formData.joinDate)
      tempErrors.joinDate = "Joining Date required";

    if (!formData.status)
      tempErrors.status = "Select Status";

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      alert("Worker Saved Successfully!");
      console.log(formData);
    }
  };

  const handleReset = () => {
    setFormData({
      workerName: "",
      mobile: "",
      role: "",
      salary: "",
      joinDate: "",
      status: ""
    });
    setErrors({});
  };

  return (
    <div>
      <h3 className="mb-4 gold-text">Inhouse Worker Master</h3>

      <div className="card p-4">
        <form onSubmit={handleSubmit}>
          <div className="row">

            {/* Worker Name */}
            <div className="col-md-6 mb-3">
              <label className="form-label">Worker Name *</label>
              <input
                type="text"
                className="form-control"
                name="workerName"
                value={formData.workerName}
                onChange={handleChange}
              />
              {errors.workerName && <small className="text-danger">{errors.workerName}</small>}
            </div>

            {/* Mobile */}
            <div className="col-md-6 mb-3">
              <label className="form-label">Mobile *</label>
              <input
                type="text"
                className="form-control"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
              />
              {errors.mobile && <small className="text-danger">{errors.mobile}</small>}
            </div>

            {/* Role */}
            <div className="col-md-6 mb-3">
              <label className="form-label">Role *</label>
              <select
                className="form-select"
                name="role"
                value={formData.role}
                onChange={handleChange}
              >
                <option value="">Select Role</option>
                <option value="Carpenter">Carpenter</option>
                <option value="Electrician">Electrician</option>
                <option value="Painter">Painter</option>
                <option value="Supervisor">Supervisor</option>
              </select>
              {errors.role && <small className="text-danger">{errors.role}</small>}
            </div>

            {/* Salary */}
            <div className="col-md-6 mb-3">
              <label className="form-label">Monthly Salary *</label>
              <input
                type="number"
                className="form-control"
                name="salary"
                value={formData.salary}
                onChange={handleChange}
              />
              {errors.salary && <small className="text-danger">{errors.salary}</small>}
            </div>

            {/* Joining Date */}
            <div className="col-md-6 mb-3">
              <label className="form-label">Joining Date *</label>
              <input
                type="date"
                className="form-control"
                name="joinDate"
                value={formData.joinDate}
                onChange={handleChange}
              />
              {errors.joinDate && <small className="text-danger">{errors.joinDate}</small>}
            </div>

            {/* Status */}
            <div className="col-md-6 mb-3">
              <label className="form-label">Status *</label>
              <select
                className="form-select"
                name="status"
                value={formData.status}
                onChange={handleChange}
              >
                <option value="">Select Status</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
              {errors.status && <small className="text-danger">{errors.status}</small>}
            </div>

          </div>

          <div className="text-end">
            <button type="button" className="btn btn-secondary me-2" onClick={handleReset}>
              Reset
            </button>
            <button type="submit" className="btn btn-warning">
              Save Worker
            </button>
          </div>

        </form>
      </div>
    </div>
  );
}

export default WorkerMaster;
